module.exports = __webpack_public_path__ + "static/media/grandegp.b12213da.png";